<section class="filter-category">
  <header class="filter-category__bar" (click)="log()">
    <h2>
      {{ title || 'Untitled category' }}
      <span *ngIf="totalSelected > 0">({{ totalSelected }})</span>
    </h2>

    <button type="button" class="block-group-toggle-button type-small" [ngClass]="{ 'is--active': !isOpen }">
      <span class="icon is--icon-plus">
        <svg class="icon-svg">
          <use xlink:href="/assets/gfx/svg-sprite.svg#icon-plus"></use>
        </svg>
      </span>

      <span class="icon is--icon-min">
        <svg class="icon-svg">
          <use xlink:href="/assets/gfx/svg-sprite.svg#icon-min"></use>
        </svg>
      </span>
    </button>
  </header>

  <div class="filter-category__content" [class.is--active]="isOpen">
    <ng-content></ng-content>
  </div> 
</section> 